import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import pnMergetagReplacer from '../../../lib/utils/pnMergeTagReplacer';
import studyConditionMergeTagReplacer from '../../../lib/utils/studyConditionMergeTagReplacer';
import { getPrimaryStudyAndConditionNames } from '../../../lib/utils/siteHelper';
import getCallCenterNumber from '../../../store/selectors/getCallCenterNumber';
import { RootState } from '../../../store/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';

type StTextItemProps = {
  inheritLinkColor?: boolean;
};

export const StText = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'inheritLinkColor',
})<StTextItemProps>(({ inheritLinkColor }) => ({
  '& a': {
    color: inheritLinkColor ? 'inherit' : 'none',
  },
}));

const TextWithStudyPnMergeTag = ({ field, cssClassName, inheritLinkColor }: any) => {
  const { sitecoreContext } = useSitecoreContext();
  const callCenterNumber = getCallCenterNumber(sitecoreContext);
  const siteSettings: any = sitecoreContext?.siteSettings;
  const cdpData = useSelector((state: RootState) => state.cdpData);
  const screenerOutcomeParameter = useSelector(
    (state: RootState) => state.megaScreener?.screenerOutcomeParameter
  );
  const { primaryStudyName, primaryConditionName } = getPrimaryStudyAndConditionNames(
    siteSettings,
    cdpData,
    screenerOutcomeParameter
  );
  const [content, setContent] = useState(field);

  useEffect(() => {
    if (callCenterNumber?.value || primaryStudyName || primaryConditionName) {
      const newContent = pnMergetagReplacer(field?.value, String(callCenterNumber?.value), false);
      const newContentWithStudyCondition = studyConditionMergeTagReplacer(
        newContent,
        primaryStudyName,
        primaryConditionName
      );
      setContent({ ...content, value: newContentWithStudyCondition });
    }
  }, [callCenterNumber?.value, primaryStudyName, primaryConditionName]);

  return (
    <StText
      field={content}
      className={cssClassName ? cssClassName : ''}
      inheritLinkColor={inheritLinkColor ? inheritLinkColor : false}
    ></StText>
  );
};

export default TextWithStudyPnMergeTag;
